import React, { useState, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { useFormik } from "formik";
import classNames from "classnames";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { handlePostRequest } from "../../services/PostTemplate";

/* eslint-disable */
const AddCashOverCounter = ({ cashOverRowData, onHide }) => {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [modePayment, setModePayment] = useState("Cash");
    const [todayDate, settodayDate] = useState(new Date());

    useEffect(() => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        var yyyy = today.getFullYear();

        today = yyyy + "-" + mm + "-" + dd;
        settodayDate(today);
    }, []);

    const handlePayment = (e) => {
        setModePayment(e.value);
    };

    const handleCancel = (e) => {
        e.preventDefault();
    };

    const menuTypeOptions = [
        { label: "form", value: "F" },
        { label: "page", value: "P" },
    ];

    const handleVerifyAccount = async (e) => {
        e.preventDefault();
        const res = await handlePostRequest({ accNo: formik.values.beneficiaryAccountNo }, "zbizgateway/nonFin/recCocTransferIFT");
        if (res) {
            formik.setFieldValue("beneficiaryAccountTitle", res.data.accountTitle);
            formik.setFieldValue("branchCode", res.data.branchName);
        }
    };

    useEffect(() => {
        formik.setFieldValue("documentType", cashOverRowData?.docType);
        formik.setFieldValue("documentNo", cashOverRowData?.docNo);
    }, [cashOverRowData]);

    const formik = useFormik({
        initialValues: {
            documentType: "",
            documentNo: "",
            expiryDate: "",
            beneficiaryAccountNo: "",
            beneficiaryAccountTitle: "",
            branchCode: "",
            paymentMode: "Cash",
            contactNumber: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.documentType) {
                errors.documentType = "This field is required.";
            }
            if (!data.documentNo) {
                errors.documentNo = "This field is required.";
            }
            if (!data.expiryDate) {
                errors.expiryDate = "This field  is required.";
            }
            if (data.expiryDate) {
                if (data.expiryDate < todayDate) {
                    errors.expiryDate = "Expiry date must be greater than today.";
                }
            }
            if (!data.contactNumber) {
                errors.contactNumber = "This field  is required.";
            }
            if (modePayment === "Transfer") {
                if (!data.beneficiaryAccountNo) {
                    errors.beneficiaryAccountNo = "This field is required.";
                }
                if (!data.beneficiaryAccountTitle) {
                    errors.beneficiaryAccountTitle = "This field is required.";
                }
                if (!data.branchCode) {
                    errors.branchCode = "This field is required.";
                }
            }
            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            data["companyId"] = cashOverRowData?.companyid;
            data["benName"] = cashOverRowData?.benName;
            data["benAddress"] = cashOverRowData?.benAddress;
            data["cashoverCounterId"] = cashOverRowData?.cashoverCounterId;
            data["productId"] = cashOverRowData?.productId;
            data["paymentMode"] = data.paymentMode === "Cash" ? "C" : "T";

            await handlePostRequest(data, "zbizgateway/nonFin/receiveCocCash");
            onHide();
            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Add Details</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-formgroup-inline">
                        <div className="p-field-radiobutton">
                            <RadioButton
                                inputId="input_outlined"
                                name="paymentMode"
                                value="Cash"
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    handlePayment(e);
                                }}
                                checked={formik.values.paymentMode === "Cash"}
                            />
                            <label htmlFor="input_outlined">Cash</label>
                        </div>
                        <div className="p-field-radiobutton">
                            <RadioButton
                                inputId="input_filled"
                                name="paymentMode"
                                value="Transfer"
                                onChange={(e) => {
                                    formik.handleChange(e);
                                    handlePayment(e);
                                }}
                                checked={formik.values.paymentMode === "Transfer"}
                            />
                            <label htmlFor="input_filled">Transfer</label>
                        </div>
                    </div>
                    {modePayment === "Cash" ? (
                        <div className="p-field p-col-12 p-md-12">
                            <div className="p-fluid p-formgrid p-grid">
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="documentType" className={classNames({ "p-error": isFormFieldValid("documentType") }, "Label__Text")}>
                                            Document Type<span className="Label__Required">*</span>
                                        </label>
                                        <InputText disabled id="documentType" placeholder="Document Type" name="documentType" value={formik.values.documentType} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("documentType") }, "Input__Round")} />
                                        {getFormErrorMessage("documentType")}
                                    </div>
                                </div>

                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="documentNo" className={classNames({ "p-error": isFormFieldValid("documentNo") }, "Label__Text")}>
                                            Document Number<span className="Label__Required">*</span>
                                        </label>
                                        <InputText disabled id="documentNo" placeholder=" documentNo Number" name="documentNo" value={formik.values.documentNo} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("documentNo") }, "Input__Round")} />

                                        {getFormErrorMessage("documentNo")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="expiryDate" className={classNames({ "p-error": isFormFieldValid("expiryDate") }, "Label__Text")}>
                                            Expiry Date
                                        </label>
                                        <InputText type="date" id="expiryDate" min={"01-02-22"} placeholder="Expiry Date" name="expiryDate" value={formik.values.expiryDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("expiryDate") }, "Input__Round")} />

                                        {getFormErrorMessage("expiryDate")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="contactNumber" className={classNames({ "p-error": isFormFieldValid("contactNumber") }, "Label__Text")}>
                                            Contact Number<span className="Label__Required">*</span>
                                        </label>
                                        <InputText id="contactNumber" placeholder="Contact Number" name="contactNumber" value={formik.values.contactNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("contactNumber") }, "Input__Round")} />

                                        {getFormErrorMessage("contactNumber")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="p-field p-col-12 p-md-12">
                            <div className="p-fluid p-formgrid p-grid">
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="documentType" className={classNames({ "p-error": isFormFieldValid("documentType") }, "Label__Text")}>
                                            Document Type<span className="Label__Required">*</span>
                                        </label>
                                        <InputText disabled id="documentType" placeholder="Document Type" name="documentType" value={formik.values.documentType} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("documentType") }, "Input__Round")} />
                                        {getFormErrorMessage("documentType")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="cnic" className={classNames({ "p-error": isFormFieldValid("cnic") }, "Label__Text")}>
                                            CNIC Number<span className="Label__Required">*</span>
                                        </label>
                                        <InputText id="cnic" disabled placeholder=" CNIC Number" name="cnic" value={formik.values.cnic} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("cnic") }, "Input__Round")} />

                                        {getFormErrorMessage("cnic")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="expiryDate" className={classNames({ "p-error": isFormFieldValid("expiryDate") }, "Label__Text")}>
                                            Expiry Date
                                        </label>
                                        <InputText type="date" id="expiryDate" placeholder="Expiry Date" name="expiryDate" value={formik.values.expiryDate} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("expiryDate") }, "Input__Round")} />

                                        {getFormErrorMessage("expiryDate")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="contactNumber" className={classNames({ "p-error": isFormFieldValid("contactNumber") }, "Label__Text")}>
                                            Contact Number<span className="Label__Required">*</span>
                                        </label>
                                        <InputText id="contactNumber" placeholder="Contact Number" name="contactNumber" value={formik.values.contactNumber} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("contactNumber") }, "Input__Round")} />

                                        {getFormErrorMessage("contactNumber")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="beneficiaryAccountNo" className={classNames({ "p-error": isFormFieldValid("beneficiaryAccountNo") }, "Label__Text")}>
                                            Account Number<span className="Label__Required">*</span>
                                        </label>
                                        <InputText
                                            id="beneficiaryAccountNo"
                                            placeholder=" Account Number"
                                            name="beneficiaryAccountNo"
                                            value={formik.values.beneficiaryAccountNo}
                                            onChange={formik.handleChange}
                                            className={classNames({ "p-invalid": isFormFieldValid("beneficiaryAccountNo") }, "Input__Round")}
                                        />

                                        {getFormErrorMessage("beneficiaryAccountNo")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <div className="Dialog__DownBtn Verify__Btn">
                                            <Button
                                                disabled={loading}
                                                onClick={(e) => {
                                                    handleVerifyAccount(e);
                                                }}
                                                label="Verify"
                                                className="DialogBtn__Dark"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="beneficiaryAccountTitle" className={classNames({ "p-error": isFormFieldValid("beneficiaryAccountTitle") }, "Label__Text")}>
                                            Account Title<span className="Label__Required">*</span>
                                        </label>
                                        <InputText
                                            id="beneficiaryAccountTitle"
                                            disabled
                                            placeholder="  Account Title"
                                            name="beneficiaryAccountTitle"
                                            value={formik.values.beneficiaryAccountTitle}
                                            onChange={formik.handleChange}
                                            className={classNames({ "p-invalid": isFormFieldValid("beneficiaryAccountTitle") }, "Input__Round")}
                                        />

                                        {getFormErrorMessage("beneficiaryAccountTitle")}
                                    </div>
                                </div>
                                <div className="p-field p-col-12 p-md-6">
                                    <div className="p-field">
                                        <label htmlFor="branchCode" className={classNames({ "p-error": isFormFieldValid("branchCode") }, "Label__Text")}>
                                            Branch Code<span className="Label__Required">*</span>
                                        </label>
                                        <InputText id="branchCode" disabled placeholder=" Branch Code" name="branchCode" value={formik.values.branchCode} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("branchCode") }, "Input__Round")} />

                                        {getFormErrorMessage("branchCode")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="Dialog__DownBtn">
                        <Button disabled={loading} label="Cancel" className="DialogBtn__Transparent" onClick={(e) => handleCancel(e)} />
                        <Button disabled={loading} label="Submit" className="DialogBtn__Dark" />
                    </div>
                </form>
            </div>
        </>
    );
};

export default AddCashOverCounter;
